import { z } from "zod";

export const emailDataSchema = z.object({
  email: z
    .string()
    .min(1, "Email é obrigatório")
    .email("Digite um email válido"),
  type: z.enum(["MANAGEMENT", "STORE"], {
    required_error: "Tipo de email é obrigatório",
    invalid_type_error: "Tipo deve ser MANAGEMENT ou STORE",
  }),
});

export const storeEmailFormSchema = z.object({
  storeCode: z.string().min(1, "Código da loja é obrigatório"),
  managementEmail: z
    .string()
    .email("Digite um email válido para gerência")
    .optional()
    .or(z.literal("")),
  storeEmail: z
    .string()
    .email("Digite um email válido para loja")
    .optional()
    .or(z.literal("")),
}).refine(
  (data) => data.managementEmail || data.storeEmail,
  {
    message: "Pelo menos um email deve ser preenchido",
    path: ["managementEmail"], // Mostra erro no primeiro campo
  }
);

export type EmailDataType = z.infer<typeof emailDataSchema>;
export type StoreEmailFormType = z.infer<typeof storeEmailFormSchema>;
